import { render, staticRenderFns } from "./collect-index.vue?vue&type=template&id=de05a230&scoped=true"
import script from "./collect-index.vue?vue&type=script&lang=js"
export * from "./collect-index.vue?vue&type=script&lang=js"
import style0 from "./collect-index.vue?vue&type=style&index=0&id=de05a230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de05a230",
  null
  
)

export default component.exports